import React from 'react'
import '../App.css'
import A from '../assets/alpha-numeric/A.svg'
import B from '../assets/alpha-numeric/B.svg'
import C from '../assets/alpha-numeric/C.svg'
import D from '../assets/alpha-numeric/D.svg'
import E from '../assets/alpha-numeric/E.svg'
import F from '../assets/alpha-numeric/F.svg'
import G from '../assets/alpha-numeric/G.svg'
import H from '../assets/alpha-numeric/H.svg'
import I from '../assets/alpha-numeric/I.svg'
import J from '../assets/alpha-numeric/J.svg'
import K from '../assets/alpha-numeric/K.svg'
import L from '../assets/alpha-numeric/L.svg'
import M from '../assets/alpha-numeric/M.svg'
import N from '../assets/alpha-numeric/N.svg'
import O from '../assets/alpha-numeric/O.svg'
import P from '../assets/alpha-numeric/P.svg'
import Q from '../assets/alpha-numeric/Q.svg'
import R from '../assets/alpha-numeric/R.svg'
import S from '../assets/alpha-numeric/S.svg'
import T from '../assets/alpha-numeric/T.svg'
import U from '../assets/alpha-numeric/U.svg'
import V from '../assets/alpha-numeric/V.svg'
import W from '../assets/alpha-numeric/W.svg'
import X from '../assets/alpha-numeric/X.svg'
import Y from '../assets/alpha-numeric/Y.svg'
import Z from '../assets/alpha-numeric/Z.svg'

export default function PhillyFridges() {
return(
  <div className="title"><span><img src={P}/><img src={H}/><img src={I}/><img src={L}/><img src={L}/><img src={Y}/></span>
							<br/>
							<span><img src={F}/><img src={R}/><img src={I}/><img src={D}/><img src={G}/><img src={E}/><img src={S}/></span></div>
)
}